module.exports = __webpack_public_path__ + "static/media/ARI-STEVI Vario 448-449.96b91e65.jpg";